const features = [
  {
    icon: 'ri-refresh-line',
    title: 'Weekly Updated',
    description: 'Our pandabuyspreadsheet is refreshed every week with the latest viral finds and trending items across all categories.',
  },
  {
    icon: 'ri-star-line',
    title: 'Quality Rated',
    description: 'Every item in the spreadsheet is community-tested and quality-rated so you only see the best budget fashion picks.',
  },
  {
    icon: 'ri-team-line',
    title: 'Community Tested',
    description: 'Thousands of global shoppers have verified these finds, ensuring you get reliable recommendations every time.',
  },
  {
    icon: 'ri-filter-3-line',
    title: 'Smart Filtering',
    description: 'Browse by category, price range, or trend score — our structured spreadsheet makes discovery effortless.',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Sourcing',
    description: 'Items sourced from the best suppliers worldwide, curated specifically for fashion-forward shoppers everywhere.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trusted Links',
    description: 'All spreadsheet links are verified and updated regularly so you never waste time on broken or outdated listings.',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-14">
          <p className="text-xs font-medium tracking-widest uppercase text-foreground-400 mb-3">Why Choose Us</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Structured Spreadsheet<br />System for Smart Shoppers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-white rounded-xl p-6 md:p-8 border border-background-200/50 hover:border-background-300/60 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className={`${feat.icon} text-2xl text-foreground-800`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}